import { useQuery } from "react-query";
import { getAccessToken } from "../../api/accessToken";
import { GET_ACCESSTOKEN } from "../constants";

const useGetAccountToken = () => {
  return useQuery([GET_ACCESSTOKEN], () => getAccessToken());
};

export default useGetAccountToken;
